<template>
  <div class="stacked-tabs flex flex-row flex-wrap w-full cursor-pointer">
    <bdg-tab
      :class="{ selected: tab === computedSelectedTab }"
      v-for="(tab, index) in tabs"
      :key="tab.text"
      :icon-class-name="tab.iconClass"
      :tab-text="getTabText(tab)"
      :is-last-odd-tab="isLastOddTab(index)"
      @click.native="changeActiveTab(tab, index)"
      :no-tab-classes="noTabClasses"
      :total-tabs="tabs ? tabs.length : 0"
    />
  </div>
</template>

<script>
import BdgTab from "./BdgTab";

export default {
  name: "StackedTabs",
  components: { BdgTab },
  props: {
    tabs: Array,
    selectedTab: Object,
    noTabClasses: Boolean,
    hideCounts: Boolean
  },
  data() {
    return {
      selectedTabIndex: 0
    };
  },
  computed: {
    computedSelectedTab: {
      get() {
        if (this.selectedTab) {
          return this.selectedTab;
        }
        return this.tabs[this.selectedTabIndex];
      },
      set(val) {
        this.$emit("tab-selected", val);
      }
    }
  },
  created() {
    if (this.selectedTab) {
      this.selectedTabIndex = this.tabs.indexOf(this.selectedTab);
    } else if (
      this.tabs.every(tab => {
        return tab.hasOwnProperty("linkTo") && tab.linkTo;
      })
    ) {
      this.selectedTabIndex = this.tabs.indexOf(
        this.tabs.find(tab => {
          return tab.linkTo === this.$route.name;
        })
      );
      if (this.selectedTabIndex === -1) {
        this.selectedTabIndex = 0;
      }
    } else {
      this.computedSelectedTab = this.tabs[this.selectedTabIndex];
    }
  },
  methods: {
    changeActiveTab(tab, index) {
      this.selectedTabIndex = index;
      this.computedSelectedTab = this.tabs[this.selectedTabIndex];

      if (
        tab.linkTo !== null &&
        tab.linkTo !== undefined &&
        this.$route.name !== tab.linkTo
      ) {
        this.$router.replace({ name: tab.linkTo });
      }
    },
    isLastOddTab(index) {
      if (this.tabs.length % 2 === 0) {
        return false;
      }

      return index === this.tabs.length - 1;
    },
    getTabText(tab) {
      if (this.hideCounts) {
        return tab.name;
      }

      return tab.count !== null && typeof tab.count !== "undefined"
        ? `${tab.name} (${tab.count})`
        : tab.name;
    }
  }
};
</script>

<style lang="scss" scoped>
body {
  :not(.sub-tabs) {
    .stacked-tabs {
      .tab {
        &:not(.tall):not(.medium):not(.partial-width):not(.full-width) {
          @screen md {
            min-width: 25%;
          }

          @screen lg {
            min-width: 20%;
          }

          @screen xl {
            min-width: 0;
          }

          &:nth-child(n + 5) {
            @screen md {
              @apply border-t-0;
            }

            @screen lg {
              @apply border-t;
            }
          }

          &:nth-child(n + 6) {
            @screen lg {
              @apply border-t-0;
            }

            @screen xl {
              @apply border-t;
            }
          }
        }

        &.partial-width {
          @apply w-1/2;

          @screen lg {
            @apply w-1/4;
          }

          &:nth-child(n + 3) {
            @apply border-t-0;

            @screen lg {
              @apply border-t;
            }
          }
        }

        &.full-width {
          @apply w-1;

          &:last-child {
            @apply border-t-0;
          }
        }
      }
    }
  }

  .sub-tabs {
    .stacked-tabs {
      .tab {
        &.partial-width,
        &.full-width {
          @screen lg {
            @apply w-1/5;
          }

          &:nth-child(6n) {
            @apply border-l;
          }

          &:nth-child(n + 6) {
            @apply border-t-0;
          }
        }

        &.full-width {
          &:nth-child(5):last-child {
            @apply border-t;
          }
        }
      }
    }
  }
}
</style>
